import { create } from 'zustand';
import { ReceiptData } from 'types';

interface ReceiptState {
  receiptData: ReceiptData | null;
  setReceiptData: (data: ReceiptData | null) => void;
  // Tracking id of the auto closing receipt
  closedTrackingId: string | null;
  setClosedTrackingId: (id: string | null) => void;
  reset: () => void;
}

export const useReceiptStore = create<ReceiptState>((set) => ({
  receiptData: null,
  setReceiptData: (data: ReceiptData | null) => set({ receiptData: data }),
  closedTrackingId: null,
  setClosedTrackingId: (id: string | null) => set({ closedTrackingId: id }),
  reset: () => set({ receiptData: null, closedTrackingId: null }),
}));
